<script>
export default {
  name: "infos"
}
</script>

<template>
  <div class="infos">
    <!--    贷款步骤-->
    <div class="infos__segment">
      <div class="infos__segment-title">
        <img src="../assets/imgs/title-symbol.svg" width="26"/>
        <span class="infos__segment-title-text">Conoce nuesto proceso</span>
        <img src="../assets/imgs/title-symbol.svg" style="transform: rotate(180deg  )" width="26"/>
      </div>
      <div class="loan-steps">
        <div class="loan-steps__item">
          <div class="loan-steps__num">
            <img src="@/assets/imgs/step-1.png"/>
          </div>
          <div class="loan-steps__des">Realiza tu<br/> solicitud en<br/> línea</div>
        </div>
        <div class="loan-steps__item">
          <div class="loan-steps__num">
            <img src="@/assets/imgs/step-2.png"/>
          </div>
          <div class="loan-steps__des">Un asesor<br/> MStar te<br/> contactará</div>
        </div>
        <div class="loan-steps__item">
          <div class="loan-steps__num">
            <img src="@/assets/imgs/step-3.png"/>
          </div>
          <div class="loan-steps__des">
            Recibe tu<br/> oferta
          </div>
        </div>
        <div class="loan-steps__item">
          <div class="loan-steps__num">
            <img src="@/assets/imgs/step-4.png"/>
          </div>
          <div class="loan-steps__des">Firma y recibe<br/> tu auto</div>
        </div>
        <div class="loan-steps__arrow">
          <img v-for="i in 3" :key="i" class="right_arrow_icon" src="../assets/imgs/right-arrow.png" alt="right arrow"/>
        </div>
      </div>
    </div>
    <!--    贷款问题-->
    <div class="infos__segment">
      <div class="infos__segment-title">
        <img src="../assets/imgs/title-symbol.svg" width="26"/>
        <span class="infos__segment-title-text">Preguntas frecuentes</span>
        <img src="../assets/imgs/title-symbol.svg" style="transform: rotate(180deg  )" width="26"/>
      </div>
      <div class="loan-faq">
        <div class="loan-faq__item">
          <div class="loan-faq__icon">
            <span class="loan-faq__icon-label">Q</span>
            <div class="loan-faq__icon-divider"></div>
          </div>
          <div class="loan-faq__body">
            <div class="loan-faq__question">¿Qué necesito para solicitar el préstamo?</div>
            <ul class="loan-faq__answer-list">
              <li>Identificación oficial vigente</li>
              <li>Comprobante de domicilio</li>
              <li>Comprobante de ingresos</li>
            </ul>
            <div class="loan-faq__note">
              Sujeto a confirmación con tu asesor MStar
            </div>
          </div>
        </div>
      </div>

    </div>
    <!--    联系方式-->
    <div class="infos__segment">
      <div class="contact">
        <div class="contact__item">
          <img class="contact__item-icon" src="@/assets/imgs/contact-phone.png"/>
          <span class="contact__item-text">+52 556-496-2656</span>
        </div>
        <div class="contact__item">
          <img class="contact__item-icon" src="@/assets/imgs/contact-email.png"/>
          <span class="contact__item-text">contacto@mstarfin.mx</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.infos {
  padding: 0.75rem;

  & > :not(:last-child) {
    margin-bottom: 1.5rem;
  }
}

.infos__segment {

}

.infos__segment-title {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1E293B;
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-bottom: 1rem;

  .infos__segment-title-text {
    margin: 0 0.5rem;
  }
}

.loan-steps {
  display: flex;
  justify-content: space-between;;
  position: relative;
  padding: 0 0.5rem;

  .loan-steps__item {
    flex: 1;

    .loan-steps__num {
      display: flex;
      align-items: center;
      justify-content: center;;
      border-radius: 100%;
      font-size: 0.8125rem;
      font-weight: 500;
      line-height: 1rem;
      margin: 0 auto 0.5rem;

      img {
        width: 1.75rem;
        height: 1.75rem;
      }
    }

    .loan-steps__des {
      color: #95A3B8;
      text-align: center;
      font-size: 0.6875rem;
      line-height: 1rem;
    }
  }

  .loan-steps__arrow {
    display: flex;
    align-items: center;
    justify-content: center;;
    position: absolute;
    top: -5px;
    left: 0;
    right: 0;
    width: calc(100% - 2.5rem);
    height: 2.25rem;
    margin: 0 auto;

    .right_arrow_icon {
      width: 1.875rem;
      height: 0.25rem;

      &:nth-child(2) {
        margin: 0 calc(((100% - 2.5rem) / 4 - 0.9375rem));
      }
    }
  }
}

.loan-faq {
  display: flex;
  flex-direction: column;
  padding: 0 0.5rem;
}

.loan-faq__item {
  display: flex;

  .loan-faq__icon {
    margin-right: 0.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    .loan-faq__icon-label {
      width: 1.25rem;
      height: 1.25rem;
      text-align: center;
      border-radius: 0.5rem 0.5rem 0.125rem 0.5rem;
      border: 1px solid #BDC7D6;
      background: #F8FAFC;
      color: #475569;
      font-size: 0.75rem;
      line-height: 1rem;
      margin-bottom: 0.5rem;
    }

    .loan-faq__icon-divider {
      flex: 1;
      width: 1px;
      background: #D5DAE2;
    }
  }
}

.loan-faq__body {
  .loan-faq__question {
    color: #475569;
    font-size: 0.8125rem;
    line-height: 1.25rem;
    margin-bottom: 0.5rem;
  }

  .loan-faq__answer-list {
    padding: 0.5rem 0 0.25rem 1.25rem;
    color: #95A3B8;
    font-size: 0.75rem;
    line-height: 1rem;
  }

  .loan-faq__note {
    color: #95A3B8;
    margin-bottom: 0.5rem;
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

.contact {
  & > :not(:last-child) {
    margin-bottom: 0.25rem;
  }

  .contact__item {
    height: 1.5rem;
    border-radius: 0.375rem;
    background: rgba(248, 250, 252, 0.40);
    display: flex;
    align-items: center;
    justify-content: center;

    .contact__item-icon {
      width: 1rem;
      height: 1rem;
      margin-right: 0.5rem;
    }
    .contact__item-text{
      color: #475569;
      font-size: 0.75rem;
      line-height: 1.25rem;
    }
  }
}


</style>